import HomeGameCard from '@gamiphy/loyalty-station-desktop/components/home/components/HomeGameCard';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { AppWelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/appWelcomeGift';
import { DiscountsStore } from '@gamiphy/loyalty-station-desktop/store/discounts';
import { GameStore } from '@gamiphy/loyalty-station-desktop/store/game';
import { ReferralsStore } from '@gamiphy/loyalty-station-desktop/store/refferals';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { WelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';
import {
  LegacyWelcomeGiftTab,
  LevelsTab, MissionsTab,
  RedeemTab, WelcomeGiftTab,
} from '@gamiphy/loyalty-station-desktop/tabs';
import ReferralTab from '@gamiphy/loyalty-station-desktop/tabs/ReferralTab';
import { Box, Grid } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

const DraftUserPage = observer(() => {
  const showLegacyWelcomeGift = React.useMemo(() => (!WelcomeGiftStore.unlocked || !WelcomeGiftStore.completed) &&
    WelcomeGiftStore.availableToUse, [WelcomeGiftStore.unlocked, WelcomeGiftStore.completed, WelcomeGiftStore.availableToUse]);

  const showWelcomeGift = React.useMemo<boolean>(
    () => !!AppWelcomeGiftStore.welcomeGift?.enabled &&
      (!DiscountsStore.welcomeGiftDiscount || DiscountsStore.isWelcomeGiftDiscountValid),
    [ThemeStore.theme, DiscountsStore.welcomeGiftDiscount, DiscountsStore.isWelcomeGiftDiscountValid],
  );

  return (
    <Box sx={{
      position: 'relative',
      height: '100%',
      width: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      marginTop: 0,
      '&::-webkit-scrollbar': {
        display: 'none',
        msOverflowStyle: 'none',
      },
      scrollbarWidth: 'none',
    }}
    >
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        sx={{
          flex: '1 1 auto',
          height: '100%',
          overflowY: 'scroll',
          overflowX: 'hidden',
          '&::-webkit-scrollbar': {
            width: '0px',
            background: 'transparent',
          },
        }}
        wrap="nowrap"
      >
        <Grid container direction="column">
          <Grid>
            <Box sx={{
              display: 'grid',
              gap: 1,
              p: 2,
              pb: 1,
            }}
            >
              <LevelsTab />
              <RedeemTab />
              {!AppStore.app.featureFlags.legacyWelcomeGift && showWelcomeGift && <WelcomeGiftTab />}
              {AppStore.app.featureFlags.legacyWelcomeGift && showLegacyWelcomeGift && <LegacyWelcomeGiftTab />}
              <MissionsTab />
              {!!ReferralsStore.appReferral?.enabled && (
                <ReferralTab />
              )}
            </Box>
          </Grid>
          {!!GameStore.appGame && GameStore.hasGames && (
            <Grid sx={{
              px: 2,
              pb: 2,
            }}
            >
              <HomeGameCard appGame={GameStore.appGame} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
});

export default DraftUserPage;
